import { Component, HostListener, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CountryService } from 'src/app/country.service';
import { environment } from 'src/environments/environment';
import { CommunicationService } from 'src/app/communication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() addlClass: string = "header-default";
  sticky = false;
  openDrawer = false;
  isMobile = false;
  country = environment.defaultCountry;
  switcher;
  @ViewChild('locationTemplate', { static: false }) template?: TemplateRef<{}>;
  constructor(private cs: CountryService, private notification: NzNotificationService, private communicationService: CommunicationService) { }

  ngOnInit(): void {
    this.country = this.cs.getCountry();
    // switch (this.country) {
    //   case "sg":
    //     if (timezone.indexOf('Hong') > 0)
    //       this.showNotification('Hong Kong', 'Singapore', 'hk');
    //     if (timezone.indexOf('Australia') > 0)
    //       this.showNotification('Australia', 'Singapore', 'au');
    //     break;
    //   case "hk":
    //     if (timezone.indexOf('Singapore') > 0)
    //       this.showNotification('Singapore', 'Hong Kong', 'sg');
    //     if (timezone.indexOf('Australia') > 0)
    //       this.showNotification('Australia', 'Hong Kong', 'au');
    //     break;
    //   case "au":
    //     if (timezone.indexOf('Singapore') > 0)
    //       this.showNotification('Singapore', 'Australia', 'sg');
    //     if (timezone.indexOf('Hong') > 0)
    //       this.showNotification('Hong Kong', 'Australia', 'hk');
    //     break;
    // }
    this.communicationService.getMessage('redirectToRegistrationPage').subscribe((_) => {
      this.redirectToRegistrationPage();
    });

    this.communicationService.getMessage('redirectToLoginPage').subscribe((_) => {
      this.redirectToLoginPage();
    });
  }

  showNotification(detected: string, actual: string, gotoCode: string) {
    this.switcher = {
      show: true,
      detected: detected,
      actual: actual,
      gotoCode: gotoCode
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    this.sticky = window.pageYOffset > 50;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    //this.screenHeight = window.innerHeight;
    this.isMobile = window.innerWidth <= 576;
  }

  redirectToRegistrationPage() {
    this.cs.redirectToRegistrationPage();
  }

  redirectToLoginPage() {
    this.cs.redirectToLoginPage();
  }

  switchCountry(c: string) {
    this.cs.setCountry(c);
    window.scrollTo(0, 0);
    window.location.reload();
  }
}
